const translations = {
    cancel: 'Cancel',
    certificationCategories: 'Certification Categories',
    certificationNumber: 'Applicator Certification Number',
    expirationDate: 'Expiration Date',
    expirationDateBeforeIssuedDate: 'Expiration date cannot be before the issue date.',
    issuedDate: 'Issued Date',
    issuedDateInFuture: 'Issue date cannot be in the future.',
    maxLengthExceeded: 'Maximum character limit exceeded.',
    saving: 'Saving…',
    state: 'State of Certification',
    statePlaceholder: 'Select a state'
};

export default translations;
